import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Pagination from '../../../HSGPagination/HSGPagination'
import { DataphiGrid } from 'dataphi-react-components/dist/Containers/Grid/DataphiGrid/DataphiGrid'

class StudentList extends React.Component{

    constructor(props){
        super(props)
        this.state = {
            selectedTab: 0,
            inSearchString: '',

            defaultLimit: 5,
            defaultOffset: 0,
            defaultSortField: 'name, class, section',
            defaultSortBy: 'desc',
            defaultSearchString: ''
        }
    }

    componentWillMount() {
        this.props.fetchStudentSearch(this.props.buildStudentHeader({inOrganizationId: this.props.organizationId}, this.props.studentHeader))
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {
        // if (nextProps.studentHeader !== this.props.studentHeader){
        //     this.props.fetchStudentSearch(this.props.buildStudentHeader({inOrganizationId: nextProps.organizationId}, nextProps.studentHeader))
        // }
    }

    showNext = where => {
        let { inLimit, inOffset } = this.props.studentHeader
        let { studentTotal, studentHeader } = this.props
        if (where === 'prev') {
            let newOffset = inOffset - inLimit < 0 ? 0 : inOffset - inLimit
            this.props.fetchStudentSearch(this.props.buildStudentHeader({ inOffset: newOffset }, studentHeader))
        } else {
            if (inOffset >= studentTotal || (inOffset + inLimit) >= studentTotal) {
                return
            }
            let newOffset = inOffset + inLimit;
            this.props.fetchStudentSearch(this.props.buildStudentHeader({ inOffset: newOffset }, studentHeader))
        }
    }

    _renderPagination = (className) => {

        const {studentHeader, studentList, studentTotal} = this.props
        return (
            studentList && studentList.length ? 
                <Pagination
                    inOffset={studentHeader.inOffset}
                    showNext={this.showNext}
                    data={studentList}
                    total={studentTotal}
                    className={className}
                /> : null
        )
    }

    search(param) {
        let inSearchString = param;
        this.props.fetchStudentSearch(
            this.props.buildStudentHeader(
                { 
                    inSearchString: inSearchString, 
                    inLimit: this.state.defaultLimit, 
                    inOffset: this.state.defaultOffset 
                }, 
                this.props.studentHeader
            )
        )
    }

    searchStudent = (e) => {
        const {inSearchString} = this.state
        e.keyCode === 13 && this.search(inSearchString.trim().toLowerCase())
    }

    updateSearchBox = e => {
        e.target.value !== this.state.inSearchString && this.setState({ inSearchString: e.target.value})
    }

    _renderToolbar = () => {
        return (
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className='search-box-container'>
                    <input onChange={(e) => {this.updateSearchBox(e)}} 
                        onKeyDown={e=>{this.searchStudent(e)}} 
                        placeholder="Type in Student Name , Admission Number or HSG-ID.." 
                        className="input-search-box" 
                        type='text' 
                        value={this.state.inSearchString} 
                    />
                </div>
            </div>
        );
    }

    formatData = data => {
        if (!!!data) {
            return []
        } else {
            let genderMap = {
                "M": "MALE",
                "F": "FEMALE",
                "O": "OTHER"
            }
            let newData = data.map((d, i) => {

                let d_object = {}
                d_object.studentname = d.name
                d_object.studentId = d.student_id
                d_object.uuid = d.uuid
                d_object.dob = d.dob
                d_object.gender = genderMap[d.gender]
                d_object.admission_number = d.admission_number
                d_object.class = d.class
                d_object.section = d.section
                return d_object
            })
            return newData
        }
    }

    getActions = (cell, row, unqIdentifier) => (
        <div className="center">
            <p onClick = {() => {this.props.openStudentProfile(row.studentId)}}>View Profile</p>       
        </div>
    )

    getTableHeader = () => {
        
        return [
            {
                dataField: 'index',
                value: 'Sl. No.',
                width: '25',
            },
            {
                dataField: 'uuid',
                value: 'HSG ID',
                width: '130'
            },
            {
                dataField: 'studentname',
                value: 'STUDENT NAME',
                width: '150'
            },
            {
                dataField: 'admission_number',
                value: 'ADMISSION NO.',
                width: '100'
            },
            {
                dataField: 'class',
                value: 'CLASS',
                width: '50'
            },
            {
                dataField: 'gender',
                value: 'GENDER',
                width: '75'
            },
            {
                dataField: 'dob',
                value: 'DOB',
                width: '100'
            },
            {
                value: 'Actions',
                phiDataFormat: (a, b, c) => this.getActions(a, b, c),
                headerAlign: 'center',
                width: '250'
            }
        ]
    }

    getData = (data = []) => {
        const rowData = data.reduce((newArr, dataElement, index)=>{
            const newDataElement = {
                ...dataElement,
                index: this.props.studentHeader.inOffset + 1 + index,
            }
            newArr.push(newDataElement)
            return newArr
        }, [])
        return rowData
    }

    _renderStudentList = (studentList) => (
        studentList && studentList.length ? 
        <DataphiGrid
            bordered={false}
            trClassName={'trClassName'}
            data={this.getData(studentList)}
            keyField={'index'}
            tableHeaderColumn={this.getTableHeader()}
            remote={true}
            boadered
            tableHeaderClass='my-header-class'
            tableBodyClass='my-body-class'
            containerClass='my-container-class'
            tableContainerClass='hsg-table-individual-report'
            headerContainerClass='my-header-container-class'
            bodyContainerClass='my-body-container-class'
        /> : this.props.noDataAvailable('Students are not enrolled.')
    )

    render(){

        let {studentList} = this.props

        return (

            <div style ={{marginTop: 20}}>
                
                <div className="col-md-12 col-sm-12 col-xs-12">
                    {this._renderToolbar()}
                </div>
                
                <div className="col-md-12 col-sm-12 col-xs-12 padding-5" style ={{marginTop: 20}}>
                    {this._renderStudentList(this.formatData(studentList))}
                </div>

                <div className="col-md-12 col-sm-12 col-xs-12 padding-10">
                    {this._renderPagination("hsg-dashboard-pagination-bottom right")}
                </div>

            </div>
        )
    }
}

export default StudentList


// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainer/Component/Student/StudentList.js